<template>
  <div class="w-full">
    <FileInput
      accept="image/png, image/jpg, image/jpeg, video/mp4, video/quicktime, video/ogg, video/webm"
      ref="input"
      @input="$emit('selected', $event)"
      multiple
      hidden
    />
    <Errors class="mb-4" :errors="input?.errors" />
    <div v-if="!props.altStyle">
      <button
        :class="{
          'bg-sky-100': props.count !== 0,
          'bg-gray-100': props.count === 0,
        }"
        class="flex items-center text-gray-900 rounded-sm border-transparent hover:bg-sky-100 transition py-2 px-3 sm:text-sm"
        @click="handleMediaSelectorOpened"
      >
        <span>{{ t("components.buttons.add_media") }}</span>
        <span
          v-if="props.count > 0"
          class="ml-1 inline-flex items-center rounded-full bg-sky-200 px-2 py-0.5 text-xs font-medium text-sky-800"
        >
          {{ props.count }}
        </span>
      </button>
    </div>
    <div v-else>
      <button
        class="text-gray-500 hover:text-gray-900 rounded-sm border-transparent transition sm:text-sm font-medium"
        @click="handleMediaSelectorOpened"
      >
        <span class="flex space-x-2 items-center" v-if="!loading">
          <CameraPlus class="w-5 h-5" />
          <span>{{ t("components.buttons.add_media") }}</span>
        </span>
        <span class="flex space-x-2 items-center" v-else>
          <LoadingSpinner class="w-5 h=5" />
          <span>{{ t("components.buttons.adding_media") }}</span>
        </span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { defineEmits, defineProps, ref } from "vue";
import CameraPlus from "@/Tailwind/Icon/CameraPlus";
import LoadingSpinner from "@/Tailwind/Components/LoadingSpinner";
import Errors from "@/Tailwind/Components/Errors.vue";
import { FileInput } from "@/Components/Inputs";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
  count: Number,
  altStyle: Boolean,
  loading: Boolean,
});

const input = ref();

defineEmits(["selected"]);

function handleMediaSelectorOpened() {
  input.value.click();
}
</script>
